import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RelocationTiming from "@/pages/tools/RelocationTiming";

export const Route = createFileRoute("/tools/relocation-timing")({
  head: () => seoHead("/tools/relocation-timing"),
  component: RelocationTiming,
});